import { FormattedMessage, FormattedNumber } from 'react-intl'

import './Summary.css'

export interface SummaryItem {
  label: string
  value: number
}

export interface SummaryProps {
  items: SummaryItem[]
  id: string
}

export default function Summary({ items, id }: SummaryProps) {
  return (
    <div className="summary-container">
      {items.map((item, index) => (
        <div
          key={index}
          className={`summary-item ${id ? `summary-${id}-${index + 1}` : ''}`}
        >
          <h2 className="summary-title">
            <FormattedMessage id={item.label} />
          </h2>
          <strong className="summary-value">
            <FormattedNumber
              value={item.value}
              notation="compact"
              compactDisplay="short"
              maximumFractionDigits={2}
            />
          </strong>
        </div>
      ))}
    </div>
  )
}
